export default {
  options: (i18n) => ([
    {
      text: i18n.t("common.none"),
      value: -1,
    },
    {
      text: i18n.tc("common.reminders.textMinutes", 5, {
        numberMinutes: 5,
      }),
      value: 5,
    },
    {
      text: i18n.tc("common.reminders.textMinutes", 10, {
        numberMinutes: 10,
      }),
      value: 10,
    },
    {
      text: i18n.tc("common.reminders.textMinutes", 15, {
        numberMinutes: 15,
      }),
      value: 15,
    },
    {
      text: i18n.tc("common.reminders.textMinutes", 30, {
        numberMinutes: 30,
      }),
      value: 30,
    },
    {
      text: i18n.tc("common.reminders.textHours", 1, {
        numberHour: 1,
      }),
      value: 60,
    },
    {
      text: i18n.tc("common.reminders.textHours", 2, {
        numberHour: 2,
      }),
      value: 120,
    },
    {
      text: i18n.tc("common.reminders.textHours", 5, {
        numberHour: 5,
      }),
      value: 300,
    },
    {
      text: i18n.tc("common.reminders.textDays", 1, {
        numberDays: 1,
      }),
      value: 1440,
    },
    {
      text: i18n.tc("common.reminders.textDays", 2, {
        numberDays: 2,
      }),
      value: 2880,
    },
  ]),
  parse: (i18n, minutes) => {
    switch (minutes) {
      case 5:
      case 10:
      case 15:
      case 30:
        return i18n.tc("common.reminders.textMinutes", minutes, {
          numberMinutes: minutes,
        });
      case 60:
      case 120:
      case 300: {
        const hours = minutes / 60;
        return i18n.tc("common.reminders.textHours", hours, {
          numberHour: hours,
        });
      }
      case 1440:
      case 2880: {
        const days = minutes / 1440;
        return i18n.tc("common.reminders.textDays", days, {
          numberDays: days,
        });
      }
      default:
        return i18n.tc("common.reminders.textMinutes", minutes, {
          numberMinutes: minutes,
        });
    }
  },
};
